export const ModalState = {
  modalType: null,
  modalProps: {}
}
